import {
  AutomationEmployeeAssistancePermission,
  AutomationEmployeePermission,
} from 'src/modules/shared/types/permissions.type';

export const EMPLOYEE_ASSISTANCE_ROUTE_PERMISSIONS = [
  AutomationEmployeeAssistancePermission.Read,
  AutomationEmployeePermission.Read,
] as const;
